import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { TimeColumnConfigDto } from '../../../types';

interface TimeColumnConfigEditorProps {
  config: TimeColumnConfigDto;
  onTypeChange: (config: TimeColumnConfigDto) => void;
}

const TIME_FORMATS = [
  { formatLabel: 'hh:mm:ss', value: 'HH:mm:ss' },
  { formatLabel: 'hh:mm', value: 'HH:mm' },
];

export function TimeColumnConfigEditor({ config, onTypeChange }: TimeColumnConfigEditorProps) {
  const { $t } = useIntl();

  const formatsWithLabels = useMemo(() => {
    const now = DateTime.now();
    return TIME_FORMATS.map((format) => ({
      ...format,
      label: `${format.formatLabel} (${now.toFormat(format.value)})`,
    }));
  }, []);

  const handleFormatChange = (format: string) => {
    onTypeChange({
      ...config,
      format,
    });
  };

  return (
    <Box marginTop={2}>
      <FormControl size="small">
        <Typography variant="caption" color="text.secondary" gutterBottom>
          {$t({
            id: 'audit.reportDefinitionEditor.columnType.time.format',
            defaultMessage: 'Formato de hora',
          })}
        </Typography>
        <Select value={config.format} onChange={(e) => handleFormatChange(e.target.value)} required>
          {formatsWithLabels.map((format) => (
            <MenuItem key={format.value} value={format.value}>
              {format.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
